import React from 'react';

import {
  ClientsPanelHeader,
  CustomEmptyDataComponent,
  CustomHeading,
} from '../../../../common/custom';
import { DeleteModal } from '../../../modals';
import CircularILoader from '../../../../common/custom/circularLoader';
import CustomContainer from '../../../../common/custom/CustomContainer';
import CustomTable from '../../../../common/custom/CustomTable/custom-table.component';

import { Tooltip } from '@material-tailwind/react';
import { useNavigate } from 'react-router-dom';
import {
  approvedIcon,
  deleteIcon,
  editIcon,
  viewIcon,
} from '../../../../assets';
import { CustomText } from '../../../../common/custom';
import { CustomIcon } from '../../../../common/customAssets';
import { PATHS } from '../../../../constants/paths';
import { usePendingShipmentsLis } from './usePendingShipmentsList';

// Update table headers to match the image - note the change from 'id' to 'name'
const PENDING_SHIPMENTS = [
  { name: 'entity', title: 'Entity' },
  { name: 'from', title: 'From' },
  { name: 'recipient', title: 'Recipient' },
  { name: 'reference', title: 'Reference' },
  { name: 'carrier', title: 'Carrier' },
  { name: 'pickup', title: 'Pickup' },
  { name: 'delivery', title: 'Delivery' },
  { name: 'value', title: 'Value' },
  { name: 'premium', title: 'Premium' },
  { name: 'confirmation', title: 'Confirmation' },
  { name: 'action', title: 'Action' },
];

// Updated action menu with the new implementation
const PendingShipmentsActionMenu = ({
  openDeleteModal,
  data,
  approveShipmentHandler,
  upper,
}) => {
  const navigate = useNavigate();
  const editHandler = (data) => {
    navigate(`${PATHS.EDIT_SHIPMENT}/${data.id}`, { state: "pending-shipment" });
  };
  const viewShipmentDetailHandler = (data) => {
    navigate(`${PATHS.VIEW_SHIPMENT_DETAILS}/${data.id}`, { state: "pending-shipment" });
  };
  
  return (
    <div
      className={`w-[190px] z-10 shadow-md bg-foundational-white  absolute ${upper ? 'top-[-60px]' : 'top-[30px]'
        }  right-[30px] rounded-[8px] flex flex-col items-center justify-center  gap-[2px] py-[4px] border-[1px] border-solid border-[#EAECF0] `}
    >
      <div
        onClick={() => {
          approveShipmentHandler(parseInt(data.id), data);
        }}
        className=' cursor-pointer flex items-center  w-full   min-h-[40px] px-[8px] hover:bg-[#F9FAFB] rounded-[6px] '
      >
        <div className='flex'>
          <Tooltip className='mt-[-10px] z-50' content='Edit'>
            <div>
              {' '}
              <CustomIcon icon={approvedIcon} />
            </div>
          </Tooltip>
          <CustomText className='font-inter font-[500] ml-[8px] text-[#228400] '>
            Approve Shipment
          </CustomText>
        </div>
      </div>

      <div
        onClick={openDeleteModal}
        className='cursor-pointer flex items-center  w-full min-h-[40px] px-[8px] hover:bg-[#F9FAFB] rounded-[6px]'
      >
        <Tooltip className='mt-[-10px] z-50' content='Delete'>
          <div>
            <CustomIcon icon={deleteIcon} />
          </div>
        </Tooltip>
        <CustomText className='font-inter font-[500] ml-[8px]'>
          <div className='font-inter font-[500] text-[#D92D20] flex gap-[12px]'>
            Delete
          </div>
        </CustomText>
      </div>

      <div
        onClick={() => editHandler(data)}
        className=' cursor-pointer flex items-center  w-full   min-h-[40px] px-[8px] hover:bg-[#F9FAFB] rounded-[6px] '
      >
        <Tooltip className='mt-[-10px] z-50' content='Edit'>
          <div>
            <CustomIcon icon={editIcon} />
          </div>
        </Tooltip>

        <CustomText className='font-inter font-[500] ml-[8px] '>
          <div>Edit</div>
        </CustomText>
      </div>
      <div
        onClick={() => viewShipmentDetailHandler(data)}
        className=' cursor-pointer flex items-center  w-full   min-h-[40px] px-[8px] hover:bg-[#F9FAFB] rounded-[6px] '
      >
        <Tooltip className='mt-[-10px] z-50' content='Edit'>
          <div>
            <CustomIcon icon={viewIcon} />
          </div>
        </Tooltip>

        <CustomText className='font-inter font-[500] ml-[8px] '>
          <div>View Details</div>
        </CustomText>
      </div>
    </div>
  );
};

const PendingShipmentsList = () => {
  const {
    data,
    handleActionClick,
    toggleActionMenu,
    actionMenuRef,
    showDeleteModal,
    openDeleteModal,
    closeDeleteModal,
    cancelShipmentHandler,
    shipmentActionClickedData,
    approveShipmentHandler,
    shipmentActionClickedId,
    loading,
  } = usePendingShipmentsLis();

  // Format the data to match what CustomTable expects
  const tableData =
    data?.map((item) => ({
      ...item, // Keep all original properties
      id: item.id,
      entity: item.entity || '---',
      from: item.from || 'MA',
      recipient: item.recipient || '---',
      reference: item.reference || '---',
      carrier: item.carrier || '---',
      pickup: item.pickup || '---',
      delivery: item.delivery || '---',
      value: item.value || '---',
      premium: item.premium || 'UNPAID',
      confirmation: item.confirmation || 'N/A',
    })) || [];

  if (tableData.length === 0 && !loading) {
    return (
      <CustomEmptyDataComponent heading='There are no Pending Shipments'>
        <ClientsPanelHeader />
      </CustomEmptyDataComponent>
    );
  }

  return (
    <>
      {showDeleteModal ? (
        <DeleteModal
          modalHeading='Delete Shipment?'
          modalPara='Are you sure you want to delete this Shipment? This action cannot be undone.'
          deleteHandler={() => cancelShipmentHandler(shipmentActionClickedId)}
          closeDeleteModal={closeDeleteModal}
        />
      ) : null}
      {loading ? (
        <div className='flex h-[126px] justify-center items-center gap-1 self-stretch px-6 py-4 rounded-xl'>
          <CircularILoader />
        </div>
      ) : (
        <CustomContainer>
          <ClientsPanelHeader />

          <div className='border-2 border-[#EAECF0] rounded-[7px]'>
            <CustomContainer className='px-6 min-h-[75px] flex justify-center items-center'>
              <CustomHeading className='text-foundation-black font-inter text-small-heading font-[600] max-w-[1152px] w-full h-full'>
                Pending Shipments
              </CustomHeading>
            </CustomContainer>
            <div className='overflow-x-auto'>
              {tableData.length > 0 ? (
                <CustomTable
                  header={PENDING_SHIPMENTS}
                  rows={tableData}
                  handleActionClick={handleActionClick}
                  toggleActionMenu={toggleActionMenu}
                  actionMenuRef={actionMenuRef}
                  // Update the menu prop to include visibility control
                  menu={
                    toggleActionMenu === shipmentActionClickedData?.id && (
                      <PendingShipmentsActionMenu
                        data={shipmentActionClickedData}
                        openDeleteModal={() =>
                          openDeleteModal(shipmentActionClickedData?.id)
                        }
                        approveShipmentHandler={approveShipmentHandler}
                        upper={true}
                      />
                    )
                  }
                />
              ) : (
                <div className='p-4 text-center'>
                  No pending shipments found
                </div>
              )}
            </div>
          </div>
        </CustomContainer>
      )}
    </>
  );
};

export default PendingShipmentsList;
